export default function CTASection() {
  return (
    <section id="contato" className="relative w-full overflow-hidden mb-2 lg:mb-4">
      <div className="flex flex-col lg:flex-row">
        <div className="w-full lg:w-1/2 relative min-h-[260px] lg:min-h-[600px]">
          <img
            src="https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/bb09bc8cbecf4a7a7895e2ea45441be4.jpeg"
            alt="Estrutura da TL Artes & Música no Jardim Paulista"
            title="TL Artes & Música - Estrutura no Jardim Paulista, Ribeirão Preto"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute top-8 left-6 right-6 md:left-12 md:right-auto z-10 [text-shadow:_0_2px_12px_rgb(0_0_0_/_60%)]">
            <span className="font-sans text-[11px] font-medium tracking-[0.2em] uppercase text-white/80">
              Jó 8:7 NVI
            </span>
            <h2 className="font-serif text-xl md:text-3xl lg:text-5xl font-bold text-white leading-[1.1] mt-2 max-w-none md:max-w-[520px]">
              "O seu começo parecerá modesto,
mas o seu futuro será de grande prosperidade."
            </h2>
          </div>
        </div>

        <div className="w-full lg:w-1/2 bg-white flex flex-col justify-start lg:justify-center items-center px-6 md:px-12 lg:px-16 py-3 lg:py-0">
          <div className="w-full max-w-[460px] flex flex-col items-center text-center gap-1">
            <h3 className="font-serif text-3xl md:text-4xl font-bold text-night-blue leading-[1.2] tracking-tight">
              Agende uma visita
            </h3>

            <p className="font-sans text-[15px] text-gray-500 leading-[1.8] max-w-[380px]">
              Conheça nossa escola no <strong className="font-semibold text-night-blue">Jardim Paulista</strong> e descubra o ambiente onde seu talento será lapidado.
            </p>

            <div className="w-full flex flex-col gap-2">
              <div className="flex items-start gap-3 text-left">
                <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-light-blue/10 mt-0.5">
                  <i className="ri-map-pin-line text-lg text-light-blue"></i>
                </div>
                <div className="flex flex-col gap-0.5">
                  <span className="font-sans text-[12px] font-semibold tracking-wider uppercase text-gray-400">Endereço</span>
                  <span className="font-sans text-sm font-medium text-night-blue leading-relaxed">
                    R. Capivari, 34 &mdash; Jardim Paulista<br />Ribeirão Preto &mdash; SP
                  </span>
                </div>
              </div>

              <div className="flex items-start gap-3 text-left">
                <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-light-blue/10 mt-0.5">
                  <i className="ri-whatsapp-line text-lg text-light-blue"></i>
                </div>
                <div className="flex flex-col gap-0.5">
                  <span className="font-sans text-[12px] font-semibold tracking-wider uppercase text-gray-400">WhatsApp</span>
                  <span className="font-sans text-sm font-medium text-night-blue">(16) 99218-8698</span>
                </div>
              </div>
            </div>

            <a
              href="https://wa.me/5516992188698?text=Ol%C3%A1%21+Vim+pelo+site+da+TL+Artes+%26+M%C3%BUsica+e+gostaria+de+saber+mais+informa%C3%A7%C3%B5es+sobre+as+aulas."
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 md:gap-3 bg-vibrant-blue hover:bg-vibrant-blue/90 text-white font-sans font-semibold text-xs md:text-sm tracking-wide uppercase px-6 md:px-10 py-3 md:py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer mt-6"
            >
              Conversar no Whatsapp
              <span className="w-6 h-6 flex items-center justify-center">
                <i className="ri-whatsapp-line group-hover:scale-110 transition-transform"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}